import React from 'react';
import { Modal } from 'antd';
import styled from 'styled-components';
import Questionnaire from '../Questionnaire/Container';

const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 8px;
    overflow: hidden;
  }
  
  .ant-modal-body {
    padding: 0;
  }

  .ant-modal-close {
    color: #fff;
  }
`;

const ModalHeader = styled.div`
  background-color: white;
  color: black;
  padding: 16px 24px;
  font-weight: 600;
  font-size: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ModalContent = styled.div`
  // padding: 20px;
  // max-height: 70vh;
  overflow-y: auto;
`;

const QuestionnaireModal = ({ 
  visible, 
  onClose, 
  corporateId, 
  roleId,
  viewRoleDetails,
  setIsApproval,
  setExternalConfirm,
  setResumePopupVisible,
  setExternalResumeApply,
  setApprovalResumeApply
}) => {
  return (
    <StyledModal
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={'80%'}
      closable={false}
      maskClosable={false}
      centered
    >
      {/* <ModalHeader>
        Questionnaire
      </ModalHeader> */}
      <ModalContent>
        <Questionnaire onClose={onClose} viewRoleDetails={viewRoleDetails} setIsApproval={setIsApproval} setExternalConfirm={setExternalConfirm} setResumePopupVisible={setResumePopupVisible} setExternalResumeApply={setExternalResumeApply} setApprovalResumeApply={setApprovalResumeApply} />
      </ModalContent>
    </StyledModal>
  );
};

export default QuestionnaireModal;
